import { fetchJsonResponse } from '@/ai/api'
import { buildWriteModelPrompt } from '@/ai/prompts'

export const generateWriteModel = async ({
  eventId,
  workflow,
  svgGraph,
  svgLanes,
  cardTypes,
  abortController
}) => {
  if (!workflow || !workflow.aiVersion) {
    return null
  }

  const messages = buildWriteModelPrompt({
    eventId,
    workflow,
    svgGraph,
    svgLanes,
    cardTypes
  })

  try {
    const response = await fetchJsonResponse({
      messages,
      aiVersion: workflow.aiVersion,
      signal: abortController?.signal
    })

    return response || null
  } catch (error) {
    return null
  }
}
